import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DF4ECEB8-EF5C-4ACC-BC7D-B4FEEE75D17D
 * name bookmark-music
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-music.svg
 * tags
 * - Music 
 */
export const BookmarkMusicIcon = createSvgIcon(<><path d="M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,11A2,2 0 0,0 9,13A2,2 0 0,0 11,15A2,2 0 0,0 13,13V8H16V6H12V11.27C11.71,11.1 11.36,11 11,11Z" /></>, 'BookmarkMusicIcon');
export default BookmarkMusicIcon